import { render, staticRenderFns } from "./DoubleNavigation.vue?vue&type=template&id=2fca5ef8&scoped=true"
import script from "./DoubleNavigation.vue?vue&type=script&lang=js"
export * from "./DoubleNavigation.vue?vue&type=script&lang=js"
import style0 from "./DoubleNavigation.vue?vue&type=style&index=0&id=2fca5ef8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fca5ef8",
  null
  
)

export default component.exports